import { render } from "./SuratPernyataan.vue?vue&type=template&id=aa28dffc&scoped=true"
import script from "./SuratPernyataan.vue?vue&type=script&lang=js"
export * from "./SuratPernyataan.vue?vue&type=script&lang=js"

import "./SuratPernyataan.vue?vue&type=style&index=0&id=aa28dffc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa28dffc"]])

export default __exports__